import React, { Fragment, useState, useContext } from 'react'
import { Redirect } from 'react-router-dom'
import { UrlServicesContext } from '../../components/UrlServicesContext'

import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import { withStyles } from '@material-ui/core/styles'
import { Button, Dialog, Grid } from '@material-ui/core'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import axios from 'axios'
import { DeleteForever } from '@material-ui/icons'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

export default function DeleteAnswer(props) {
  const classes = useStyles()

  const [error, setError] = useState(false)
  const [mensaje_error, setMensaje_error] = useState('')
  const [openAlertSuccess, setOpenAlertSuccess] = useState(false)
  const [mensaje_success, setMensaje_success] = useState('')
  const [disabled, setdisabled] = useState(false)
  const [returnLogin, setReturnLogin] = React.useState(false)

  let id = Number(props.id)

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  const handleCloseDialog = (pro) => (event) => {
    props.exit()
  }

  const handleChangeDelete = (event) => {
    axios
      .delete(`${urlServices}answers/${id}`, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      .then((response) => {
        // Filtrar el array de respuestas para excluir el elemento con el ID eliminado
        const updatedAnswers = props.data.answer.filter(
          (row1) => row1.id !== id
        )

        // Actualizar el array de respuestas
        props.data.answer = updatedAnswers

        // Desactivar el botón después de la eliminación
        setdisabled(true)

        // Ejecutar la función de callback para refrescar la pantalla con las respuestas actualizadas
        props.callBackRefresh(props.data.answer)

        // Mostrar mensaje de éxito
        setOpenAlertSuccess(true)
        setMensaje_success('Eliminado con Éxito.')
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          setError(true)
          setMensaje_error('Error al eliminar')
        }
      })
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers>
          <form noValidate autoComplete="off">
            <Grid container spacing={2}>
              {!openAlertSuccess ? (
                <>
                  <Grid item xs={12} md={12}>
                    {error && <Alert severity="error">{mensaje_error}</Alert>}
                    <center>
                      <DeleteForever className={classes.iconDelete} />
                      <div className={classes.titleCardFilter}>
                        ¿Desea eliminar este registro?
                      </div>
                      <Alert severity="error">
                        Se eliminará permanentemente esta respuesta.
                      </Alert>
                    </center>
                  </Grid>
                  <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
                    <center>
                      <Button
                        className={classes.buttonSubmit2}
                        onClick={handleChangeDelete}
                        disabled={disabled}
                      >
                        Eliminar
                      </Button>
                    </center>
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} md={12} style={{ margin: '20px 0' }}>
                  <Alert severity="success">{mensaje_success}</Alert>
                </Grid>
              )}
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.buttonRight}
            onClick={handleCloseDialog(true)}
            style={{ marginRight: 25 }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}
